@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body, #root {
    height: 100%;
    overflow: hidden;
  }

  body {
    font-family: 'Inter', system-ui, sans-serif;
    background-color: #0a0f1a;
    color: #e5e7eb;
    -webkit-font-smoothing: antialiased;
  }

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb {
    background: #374151;
    border-radius: 9999px;
  }
  ::-webkit-scrollbar-thumb:hover { background: #4b5563; }
}

@layer components {
  .glass {
    background: rgba(255, 255, 255, 0.04);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.08);
  }

  .glass-hover {
    @apply glass transition-all duration-200 hover:bg-white/[0.07] hover:border-white/[0.12];
  }

  .btn-primary {
    @apply px-4 py-2 bg-brand-600 hover:bg-brand-700 text-white rounded-xl font-medium
           transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed;
  }

  .btn-ghost {
    @apply px-4 py-2 text-dark-300 hover:text-white hover:bg-white/[0.06]
           rounded-xl font-medium transition-all duration-200 active:scale-95;
  }

  .input-base {
    @apply w-full bg-dark-700 border border-dark-600 rounded-xl px-4 py-3 text-white
           placeholder-dark-400 outline-none transition-all duration-200
           focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20;
  }

  .message-bubble-sent {
    @apply bg-brand-600 text-white rounded-2xl rounded-br-sm px-4 py-2.5 max-w-xs lg:max-w-md;
  }

  .message-bubble-recv {
    @apply bg-dark-700 text-gray-100 rounded-2xl rounded-bl-sm px-4 py-2.5 max-w-xs lg:max-w-md;
  }

  .online-dot {
    @apply w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-dark-800;
  }

  .sidebar-item {
    @apply flex items-center gap-3 px-3 py-3 rounded-xl cursor-pointer
           transition-all duration-150 hover:bg-white/[0.06] active:scale-[0.98];
  }

  .sidebar-item-active {
    @apply bg-brand-600/20 border border-brand-500/30 text-white;
  }

  .avatar {
    @apply rounded-full object-cover bg-dark-600 flex-shrink-0;
  }

  .typing-dot {
    @apply w-2 h-2 bg-dark-400 rounded-full;
    animation: typing 1.2s infinite;
  }
  .typing-dot:nth-child(2) { animation-delay: 0.2s; }
  .typing-dot:nth-child(3) { animation-delay: 0.4s; }
}

/* Custom animations */
@keyframes messageIn {
  from { opacity: 0; transform: translateY(6px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.message-animate {
  animation: messageIn 0.2s ease-out;
}

/* Shimmer loading */
@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.shimmer {
  background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
